if(typeof FN == 'undefined') FN = {};


FN.contentNavigationConfig = {
  selectors: {
    openCloseSelector: '.navbar__contentnavigation a',
    navigationContainerSelector: '#content-nav'
  }
}


FN.contentNavigation = {
  init: function() {
    var opencloseSelector = FN.contentNavigationConfig.selectors.openCloseSelector;
    $(opencloseSelector).on('click', FN.contentNavigation.__toggleNavigation);
    var itemLinkSelector = FN.contentNavigationConfig.selectors.navigationContainerSelector + ' > ul > li > a';
    $(itemLinkSelector).click(FN.contentNavigation.__selectItem);
  },
    
  __toggleNavigation: function(event){
    event.preventDefault();
    
    var toggleEl      = $(FN.contentNavigationConfig.selectors.openCloseSelector);
    var navigationEl  = $(FN.contentNavigationConfig.selectors.navigationContainerSelector);
    var openState     = navigationEl.hasClass('open');
    if(openState === true){
      var removeClass = 'open';
      var addClass = 'closed';
    }else{
      var removeClass = 'closed';
      var addClass = 'open';
    }
    navigationEl.removeClass(removeClass).addClass(addClass);
    toggleEl.removeClass(removeClass).addClass(addClass);
  },
  
  
  __selectItem: function(event){
    var href = $(this).attr('href');
    if(!href || href === '#'){
      event.preventDefault();
    	$(this).parents('li').toggleClass('expanded').children('ul').stop().slideToggle(200);
    }
  }
};




$(document).ready(function(){
  FN.contentNavigation.init();
});
